export default __webpack_public_path__ + "assets/models/1714070245a27a04ff9adec0ea8f59f1.glb";